import {
    Box,
    Dialog,
    IconButton,
    Theme,
    Typography
} from "@mui/material";
import {
    DialogCloseIcon,
    YellowWarning
} from "../../../assets/SvgIcons";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { MAX_SCHEMES_SELECTED, USER_ROLES } from "../../../utils/constant";
import { ToWords } from "to-words";

interface FiveSchemesDialogProps {
    isVisible: boolean;
    onClose: () => void;
}

export default function FiveSchemesDialog({
    isVisible,
    onClose
}: FiveSchemesDialogProps): JSX.Element {

    const toWords = new ToWords();

    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);

    return (
        <Dialog
            onClose={onClose}
            open={isVisible}
            maxWidth='sm'
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '12px',
                    backgroundColor: theme.palette.common.white,
                    padding: "22px 24px",
                    width: "533px",
                },
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "8px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            columnGap: "12px",
                            alignItems: "center"
                        }}
                    >
                        <YellowWarning />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                        >
                            {MAX_SCHEMES_SELECTED} schemes at a time!
                        </Typography>
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            padding: "5px"
                        }}
                    >
                        <DialogCloseIcon />
                    </IconButton>
                </Box>
                <Typography
                    variant="subtitle_400"
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.secondary,
                    })}
                >
                    You can  {![USER_ROLES.INVESTOR].includes(role) ? "recommend" : "proceed"} up to {`${toWords.convert(MAX_SCHEMES_SELECTED)}`.toLowerCase()} schemes simultaneously!
                </Typography>
            </Box>
        </Dialog>
    )
}